import { RouteComponentProps } from 'react-router-dom'

import CaseLayout from '../../layouts/CaseLayout/CaseLayout'
import POI from '../../components/POI/POI'
import Scene from '../../components/Scene/Scene'
import { useEffect } from 'react'
import { HEADER_HEIGHT } from '../../shared/constants/global'

interface LeadParams {
  poiId?: string
  sceneId?: string
}

type LeadProps = RouteComponentProps<LeadParams>

const Lead = (props: LeadProps) => {
  const { match } = props
  const { poiId, sceneId } = match.params

  // Jump to top on mount
  useEffect(() => {
    window.scrollTo({ top: HEADER_HEIGHT + 5, left: 0, behavior: 'auto' })
  }, [match.params])

  const renderZoneContent = () => {
    if (poiId) {
      return <POI poiId={poiId} />
    } else if (sceneId) {
      return <Scene sceneId={sceneId} />
    } else {
      return null
    }
  }

  return (
    <CaseLayout floatingHeader={true} alwaysShowNav={false}>
      {renderZoneContent && renderZoneContent()}
    </CaseLayout>
  )
}

export default Lead
